import { render, staticRenderFns } from "./staff-add.vue?vue&type=template&id=05632cdf&scoped=true&"
import script from "./staff-add.vue?vue&type=script&lang=js&"
export * from "./staff-add.vue?vue&type=script&lang=js&"
import style0 from "./staff-add.vue?vue&type=style&index=0&id=05632cdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05632cdf",
  null
  
)

export default component.exports